<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title" style="display: flex;align-items: center;">
					ប្រវត្តិភ្នាល់អតិថិជន
					<router-link :to="'/clients/detail/' + client.hash">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">ព័ត៌មានអតិថិជន</md-tooltip>
						</md-button>
					</router-link>
					<router-link :to="'/clients/game_detail/' + client.hash">
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>gamepad</md-icon>
								<md-tooltip md-direction="top">ប្រវត្តិបើកហ្គេមទាំងអស់</md-tooltip>
						</md-button>
					</router-link>
				</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដ</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.id).length > 0"><b>m-{{config.orderlify(client.id)}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះចូលប្រព័ន្ធ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.hash_id).length > 0"><b>{{client.username}} <md-icon class="verify" v-if="client.verified == 1">verified</md-icon></b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>


				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0"><b>{{client.name}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0"><b>{{client.phone}}</b></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ប្រវត្តិភ្នាល់ទាំងអស់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100" style="overflow-x: scroll;">
					<table v-if="userBet.length > 0" style="width: 100%;min-width: 900px">
						<tr>
							<td>ល.រ</td>
							<td>លេខកូដ</td>
							<td>ប្រភេទ</td>
							<td>ចំនួន</td>
							<td>ឈ្មោះអ្នកផ្តល់សេវា</td>
							<td>កាលបរិច្ឆេទ</td>
						</tr>
						<tr v-for="(bet, index) in userBet">
							<td>{{index + 1}}</td>
							<td>{{bet.hash}}</td>
							<td>{{bet.type}}</td>
							<td>
								{{ config.moneylify(bet.amount) }}
								<!-- <span class="green" v-if="bet.amount > 0">{{ config.moneylify(bet.amount) }}</span>
								<span class="late" v-if="bet.amount < 0">{{ config.moneylify(bet.amount) }}</span> -->
							</td>
							<td>{{bet.name}}</td>
							<td>{{config.datelifyFull(bet.created_date)}}</td>
						</tr>
					</table>
					<h4 class="text-center" v-if="userBet.length == 0 && loadMore == false">មិនមានប្រវត្តិ</h4>
					<div class="places-buttons text-center" v-if="loadMore">
						<md-button class="md-primary" @click="getBet(true)">បង្ហាញបន្ថែម</md-button>
					</div>
			</div>

		</div>
	</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getClient();
			this.getBet();
		},

		data() {
			return {
				tabName: "5",
				loaded: false,
				loadMore: false,
				userBet: [],
				client: {
					hash_id: "",
					name: "",
					phone: "",
					note: "",
					created_date: ""
				},
			}
		},
		watch: {
		},
		computed: {
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/user/get/" + this.$route.params.hash_id).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
				// this.$http.get(this.config.api + "/admin/user/get_stat/" + this.$route.params.hash_id).then(data => {
				// 	this.data = data.body.data
				// })
				// this.getBetToday();
			},
			getBet(more = false) {
				let offset = more ? this.userBet.length : 0;

				let provider_id = this.$route.params.provider_id;
				if(provider_id != undefined) {
					this.$http.get(this.config.api + "/admin/user/get_bet/" + this.$route.params.hash_id + "/" + provider_id + "/" + offset).then(data => {
						if (data.body.data.length == 500) this.loadMore = true;
						else this.loadMore = false;
						this.userBet = more ? this.userBet.concat(data.body.data) : data.body.data;
					})
				} else {
					this.$http.get(this.config.api + "/admin/user/get_bet/" + this.$route.params.hash_id + "/" + offset).then(data => {
						if (data.body.data.length == 500) this.loadMore = true;
						else this.loadMore = false;
						this.userBet = more ? this.userBet.concat(data.body.data) : data.body.data;
					})
				}

			},
			refresh() {
				if(this.tabName == '5') {
					this.getBetToday();
				} else if (this.tabName == '6') {
					this.getBetMonthly();
				} else if(this.tabName == '7') {
					this.getBetRange();
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/BetDetail.vue